import { Container, styled } from "@mui/material";

export const MuiContainer = styled(Container)`
    margin-top: 1.875rem;
    padding-bottom: 5rem;
`;
